<template>
  <div></div>
</template>

<script>
export default {
  name: "questionnaire",
};
</script>

<style scoped></style>
